import { GridAction } from '@eforall/dashboard';
import { SurveysBySessionRow } from '../surveys-by-session-view.part';

export function getActions() {

	const actions: GridAction<SurveysBySessionRow>[] = [];

	return actions;
}